import React from 'react';

import { SVGProps } from './SVG.props';

const NewLogoSmall = (props: SVGProps): React.JSX.Element => {
  const { width, height, fill } = props;
  return (
    <svg
      width={width || '54'}
      height={height || '68'}
      viewBox="0 0 54 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6241_10938)">
        <path
          d="M27.0706 47.8676C38.7364 47.8676 48.1935 38.4513 48.1935 26.8356C48.1935 15.2199 38.7364 5.80359 27.0706 5.80359C15.4048 5.80359 5.94775 15.2199 5.94775 26.8356C5.94775 38.4513 15.4048 47.8676 27.0706 47.8676Z"
          fill="#91DBB6"
        />
        <path
          d="M53.8992 26.7284C53.8992 12.0488 41.8695 0.170013 27.0035 0.170013C12.1376 0.170013 0.107788 12.0488 0.107788 26.7284C0.107788 41.4079 12.1376 53.2865 27.0035 53.2865C30.3044 53.2865 33.4585 52.7072 36.368 51.6209C32.0402 55.9426 26.6123 59.1536 20.7196 60.7954L22.7001 67.7729C31.5024 65.3344 39.4487 59.9988 45.048 52.8037C50.8427 45.3672 53.8992 36.4582 53.8992 27.0663V26.7284ZM7.4431 26.7284C7.4431 16.0808 16.2208 7.41314 27.0035 7.41314C37.7863 7.41314 46.564 16.0808 46.564 26.7284C46.564 37.3759 37.7863 46.0435 27.0035 46.0435C16.2209 46.0435 7.4431 37.3759 7.4431 26.7284Z"
          fill="#12100E"
        />
        <path
          d="M27.0036 33.9714C31.0547 33.9714 34.3389 30.7285 34.3389 26.7283C34.3389 22.7281 31.0547 19.485 27.0036 19.485C22.9526 19.485 19.6685 22.7279 19.6685 26.7283C19.6685 30.7286 22.9524 33.9714 27.0036 33.9714Z"
          fill="#12100E"
        />
      </g>
      <defs>
        <clipPath id="clip0_6241_10938">
          <rect width="54" height="68" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NewLogoSmall;
